import VadImage from "vadimages-nextjs-image-optimizer";

const StandardizedTechSection = () => {
    return (
        <div className='grid grid-cols-3 gap-6 [&>div]:rounded-default [&>div]:overflow-hidden'>
            <div className='col-span-2'>
                <VadImage
                    src={`/images/singular/custom-1.png`}
                    alt={`Custom-1`}
                    width={684}
                    height={710}
                    className='w-full h-full'
                />
            </div>
            <div>
                <VadImage
                    src={`/images/singular/custom-2.png`}
                    alt={`Custom-2`}
                    width={448}
                    height={710}
                    className='w-full h-full'
                />
            </div>
            <div className='col-span-3'>
                <VadImage
                    src={`/images/singular/custom-3.png`}
                    alt={`Custom-3`}
                    width={1156}
                    height={484}
                    className='w-full h-full'
                />
            </div>
        </div>
    );
};

export default StandardizedTechSection;